import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function initItemCards() {

	const itemCards = document.querySelectorAll('.item-cards');

	itemCards.forEach(el => {
		const slider = el.querySelector('.swiper');

		const swiper = new Swiper(slider, {
			modules: [Navigation],
	    slidesPerView: 'auto',
	    simulateTouch: true,
	    slidesOffsetBefore: 24,
	    slidesOffsetAfter: 24,
	    spaceBetween: 20,
	    loop: true,
	    speed: 600,
		  // Navigation arrows
		  navigation: {
		    nextEl: el.querySelector('.swiper-button-next'),
		    prevEl: el.querySelector('.swiper-button-prev'),
		  },
		  breakpoints: {
		  	992: {
	   			slidesOffsetBefore: 60,
	    		slidesOffsetAfter: 100,
			    spaceBetween: 36,
			  },
		    1440: {
	    		slidesOffsetAfter: 200,
		    },
		    1920: {
		    	slidesOffsetAfter: 1000
		    },
		    2200: {
		    	slidesOffsetAfter: 1200
		    }
		  }
	  });

	});


}